/**
 * @file
 * A JavaScript file for making selectboxes customizable
 *
 */

(function (Drupal, $) {
  Drupal.behaviors.niceSelect = {
    attach: function (context) {
      'use strict';
      $('select').niceSelect();
    }
  }
})(Drupal, jQuery);
